import React from 'react';
import Panel from './Panel';
import VendasPorVendedor from '../../components/Panel/Salesmans/VendasPorVendedor';

const VendasPorVendedorPage = () => {

  return (
    <Panel>
      <div>
        <VendasPorVendedor />
      </div>
    </Panel>

  );
};

export default VendasPorVendedorPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/VendasPorVendedorPage.js
 **/